// Intended to be thrown from saga workers to stop the execution of next steps in mediator
import BaseError from './BaseError';

class ShortCircuitError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('ShortCircuitError', message, fileName, lineNumber);
  }
}

export default ShortCircuitError;
